import ConfigNode from 'Model/ConfigNode'

class ActionsPage extends ConfigNode

  @className: 'ActionsPage'

  constructor: (id) ->
    super(id)
    @set('title', 'New Service') unless @get('title')
    @set('component', 'simple') unless @get('component')

  toPlainObj: ->
    conf = {
      title: @get('title')
      component: @get('component')
      description: @get('description')
      key: @id()
      serviceName: @get('serviceName')
      serviceCall: @get('serviceCall')
      (@get('parameters') or {})...
    }

  @load: (id) ->
    super(id, @)

export default ActionsPage
